import { ProductGroup } from '@@partner:types:app'
import { CommonPager, CommonSort, NestedFilter, PageInfo } from '@@partner:types:graphql'
import { gql, useQuery } from '@apollo/client'
import { SHORTCUT_PAGE_INFO_FIELDS, SHORTCUT_PRODUCT_GROUP_FIELDS } from '@@partner:graphql/shortcuts'

export interface AllProductGroupsQuery {
  allProductGroups: {
    edges: ProductGroup[]
    pageInfo: PageInfo
  }
}

export interface AllProductGroupsVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager?: CommonPager
}

export const GQL_QUERY_ALL_PRODUCT_GROUPS = gql`
  query allProductGroups(
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    allProductGroups(
      filter: $filter
      sort: $sort
      pager: $pager 
    ) {
      edges {
        ${SHORTCUT_PRODUCT_GROUP_FIELDS}
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }
`

export const useFetchAllProductGroups = (variables?: AllProductGroupsVariables) => 
  useQuery<AllProductGroupsQuery, AllProductGroupsVariables>(GQL_QUERY_ALL_PRODUCT_GROUPS, {
    variables,
    fetchPolicy: 'network-only'
  })